import Drawer from '@material-ui/core/Drawer'

import { FormTitle } from 'components/Maintainance/components'
import SiteDetails from './SiteDetails'

const ViewSite = ({ open, onClose, siteDetails }) => {
  return (
    <Drawer anchor='right' open={open} onClose={onClose} style={{ width: '100%' }}>
      <FormTitle title='Facility Details' closeFunc={onClose} style={{ width: '100%' }} />
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 65px)', height: 'calc(100vh - 65px)', background: '#efefef', width: '500px' }}>
        <div style={{ padding: '20px' }}>
          <SiteDetails siteDetails={siteDetails} />
        </div>
      </div>
    </Drawer>
  )
}

export default ViewSite
